import type { SchedulingHoursDay } from "@core/types";

// PLAN-009 §7.2 (P8-2): admin.jsx:432-440 dibuja UN input de texto por día
// ("08:00–17:00" o "Cerrado"), no la casilla + dos `input type="time"` que
// tenía la corrida anterior. Este módulo concentra el parseo/formateo para
// poder probarlo sin montar la pantalla completa.

const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;
const SEPARATOR_RE = /\s*[-–]\s*/;
export const INVALID_HOURS_MESSAGE = "Usa HH:MM–HH:MM o Cerrado";
const CLOSING_BEFORE_OPENING_MESSAGE =
  "La hora de cierre debe ser posterior a la de apertura";

export type HoursParseResult =
  | {
      ok: true;
      closed: boolean;
      opensAt: string | null;
      closesAt: string | null;
      display: string;
    }
  | { ok: false; message: string };

/** Texto inicial de la tarjeta a partir de la franja que devuelve el
 * servidor (`GET .../hours`). */
export function formatHoursEntry(day: SchedulingHoursDay | undefined): string {
  if (!day || day.closed || !day.opensAt || !day.closesAt) return "Cerrado";
  return `${day.opensAt}–${day.closesAt}`;
}

/** Parsea lo que escribió el operador. Acepta `–`, `-` y ` - ` como
 * separador (normalizados a `–` en `display`), y `Cerrado`/`cerrado`. */
export function parseHoursEntry(raw: string): HoursParseResult {
  const trimmed = raw.trim();
  if (trimmed.toLowerCase() === "cerrado") {
    return {
      ok: true,
      closed: true,
      opensAt: null,
      closesAt: null,
      display: "Cerrado",
    };
  }
  const parts = trimmed.split(SEPARATOR_RE);
  if (parts.length !== 2) {
    return { ok: false, message: INVALID_HOURS_MESSAGE };
  }
  const [opensAt, closesAt] = parts;
  if (
    !opensAt ||
    !closesAt ||
    !TIME_RE.test(opensAt) ||
    !TIME_RE.test(closesAt)
  ) {
    return { ok: false, message: INVALID_HOURS_MESSAGE };
  }
  if (closesAt <= opensAt) {
    return { ok: false, message: CLOSING_BEFORE_OPENING_MESSAGE };
  }
  return {
    ok: true,
    closed: false,
    opensAt,
    closesAt,
    display: `${opensAt}–${closesAt}`,
  };
}
